
import { Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import type { MenuProps } from "antd";

interface Props {
  id: string;
}

const TableActionMenu: React.FC<Props> = ({ id }) => {
  const navigate = useNavigate();

  const items: MenuProps["items"] = [
    {
      label: "Update",
      key: "update",
    },
    {
      label: "View Details",
      key: "view",
    },
  ];

  const onClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "update") {
      navigate(`/recruiter/update-job/${id}`);
    }
    else if (key === "view") {
      navigate(`/recruiter/view-job/${id}`);
    }
  };

  return (
    <Dropdown
      menu={{ items, onClick }}
      trigger={["click"]}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
    >
      <MoreOutlined />
    </Dropdown>
  );
};

export default TableActionMenu;
